<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import isIOS from '@/util/isIOS'
export default {
  data () {
    return {
      isIOS: isIOS()
    }
  },
  mounted () {
    if (isIOS()) {
      document.body.classList.add('ios')
    }
  }
}
</script>

<style lang="scss">
@import url(~@/style/reset.scss);
#app {
  font-family: PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.van-toast .van-toast__text {
  font-size: 24px;
}

.ios {
  .van-toast.van-toast {
    width: fit-content;
    min-height: 1.5em;
  }
  .van-toast .van-toast__text {
    font-size: 24px;
    line-height: 36px;
  }
  .van-toast .van-toast__icon {
    font-size: 64px;
  }
}
</style>
